import { useAuth } from '@beukay/auth-mall';
import { useMemoizedFn } from 'ahooks';
import { history } from 'umi';

export const useAuthLogin = () => {
  const { user } = useAuth();

  const locateToLogin = () => {
    const { href } = window.location;
    history.push({
      pathname: '/login',
      search: `callBackUrl=${encodeURIComponent(href)}`,
    });
  };

  const onAuthLogin = async (
    callback?: (...args: any) => Promise<any> | void,
  ) => {
    if (!user?.userId) return locateToLogin();
    return await callback?.();
  };

  return {
    locateToLogin: useMemoizedFn(locateToLogin),
    onAuthLogin: useMemoizedFn(onAuthLogin),
  };
};
